import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sales from "./pages/Sales";
import StoryTelling from "./pages/StoryTelling";
import Final from "./pages/Final";
import ScrollToTop from "./ScrollToTop";
import { useEffect } from "react";
import { initFacebookPixel } from "./pixel"; // حسب مكان الملف

function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/Sales" element={<Sales />} />
        <Route path="/" element={<StoryTelling />} />
        <Route path="/final" element={<Final />} />
      </Routes>
    </Router>
  );
}

export default App;
